export let CommonLinks = {
    notFound: () => "/404",
}
